import { Component, Output, EventEmitter, OnDestroy } from '@angular/core';
import { ComponentBase } from '../component-base';
import { SceneUtilsService } from '../services/scene-utils.service';
import { StageService } from '../services/stage.service';
import { BuildWallService } from '../services/build-wall.service';
import { RemoveWallService } from '../services/remove-wall.service';
import { DragWallEdgesService } from '../services/drag-wall-edges.service';
import { SetWallMaterialService } from '../services/set-wall-material.service';
import { Select3dService } from '../services/select-3d.service';
import { DragFloorEdge } from '../services/drag-floor-edge.service';
import { DataForDisplayingMenuItemsService } from '../services/data-for-displaying-menu-items.service';
declare let THREE: any;

@Component({
  selector: 'app-add-walls',
  templateUrl: './add-walls.component.html',
  styleUrls: ['./add-walls.component.scss']
})
export class AddWallsComponent extends ComponentBase implements OnDestroy {

  private raycaster: any = new THREE.Raycaster();
  private currentMaterialIndex: number;
  isSelected = false;
  subMenu = [];
  selectedWallType: string = '';

  @Output() step1Editer = new EventEmitter();

  goBack(value) {
    this.step1Editer.emit({ name: value });
  }

  constructor(
    private sceneUtils: SceneUtilsService,
    private stage: StageService,
    private buildWallService: BuildWallService,
    private removeWallService: RemoveWallService,
    private dragWallEdgesService: DragWallEdgesService,
    private wallMaterialSrvc: SetWallMaterialService,
    private select3D: Select3dService,
    private dragFloorEdge: DragFloorEdge,
    private dataForDisplayingMenuItemsService: DataForDisplayingMenuItemsService
  ) {
    super();
    this.dataForDisplayingMenuItemsService.changeSelectedMenuItem.subscribe(value => {
      this.selectedWallType = value;
    })
  }

  mouseDown(e) {
    const p = this.sceneUtils.getRay(e.offsetX, e.offsetY);
    this.raycaster.ray.origin.copy(p.ray.origin);
    this.raycaster.ray.direction.copy(p.ray.direction);

    const floor = this.stage.getCompoundFloor();
    const sprites = this.stage.getSprites();
    const intersection = this.raycaster.intersectObjects([...floor.children, ...sprites]);
    if (!intersection.length) {
      if(this.selectedWallType === 'remove'){
        this.dataForDisplayingMenuItemsService.changeSelectedMenuItem.next('')
      }
      this.remove();
    }
  }

  buildWall(index): void {
    this.wallMaterialSrvc.setCurrentTexture(index);
    const selectedWall = this.select3D.getSelectedWall();
    if (!selectedWall) {
      if (!this.buildWallService.isEnabled() || this.currentMaterialIndex !== index) {
        this.currentMaterialIndex = index;
        this.remove();
        this.buildWallService.enable();
        this.dragFloorEdge.disable();
        this.buildWallService.drawSprites();
      } else {
        this.buildWallService.disable();
        this.dragFloorEdge.enable();
      }
    } else {
      this.wallMaterialSrvc.changeSelectedWallMaterial();
    }
    this.dragWallEdgesService.enable();
  }

  removeWall() {
    if (!this.removeWallService.isEnabled()) {
      this.remove();
      this.removeWallService.enable();
      this.removeWallService.drawSprites();
      this.dataForDisplayingMenuItemsService.changeSelectedMenuItem.next('remove');
    } else {
      this.removeWallService.removeSprites();
      this.removeWallService.disable();
      this.dataForDisplayingMenuItemsService.changeSelectedMenuItem.next('');
    }
  }

  remove() {
    this.removeWallService.removeSprites();
    this.removeWallService.disable();
    this.buildWallService.disable();
    this.dragFloorEdge.enable();
  }

  selectSection(section) {
    this.isSelected = true;
    this.wallMaterialSrvc.setSection(section);
    this.subMenu = this.wallMaterialSrvc.getSpritesBySection(section);
    this.dataForDisplayingMenuItemsService.changeSelectedMenuItem.next(section)
  }

  ngOnDestroy() {
    this.isSelected = false;
  }

}



// WEBPACK FOOTER //
// ./src/app/add-walls/add-walls.component.ts